import React from "react";

const Email = ({ color = "rgba(255, 255, 255, 0.4)", ...props}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="17"
      height="13"
      viewBox="0 0 17 13"
      fill="none"
      {...props}
    >
      <path
        d="M2.32296 12.3516C1.93911 12.3516 1.61051 12.2148 1.33714 11.9413C1.0638 11.6678 0.927124 11.339 0.927124 10.9549V2.1165C0.927124 1.7324 1.0638 1.40472 1.33714 1.13346C1.61051 0.862195 1.93911 0.726562 2.32296 0.726562H15.1146C15.4985 0.726562 15.8271 0.863319 16.1004 1.13683C16.3738 1.41035 16.5105 1.73915 16.5105 2.12323V10.9616C16.5105 11.3457 16.3738 11.6734 16.1004 11.9447C15.8271 12.2159 15.4985 12.3516 15.1146 12.3516H2.32296ZM8.71879 7.46615L2.32296 3.78906V10.9557H15.1146V3.78906L8.71879 7.46615ZM8.71879 5.78906L15.0938 2.1224H2.34379L8.71879 5.78906ZM2.32296 3.78906V2.1224V10.9557V3.78906Z"
        fill={color}
      />
    </svg>
  );
};

export default Email;
